export default __webpack_public_path__ + "static/media/5_Intro.9448f221.mp4";